import React from 'react'
import { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { CustomPagination } from '../../../components/common/table-pagination/CustomPagination';
import logger from '../../../utils/logger';
import { motion } from 'framer-motion';
import { LoadingComponent } from '../../common/LoadingComponent/LoadingComponent';
import { UseSettingColumns } from '../../../hooks/DataTable-hooks/useVisibleCols';
import { dateFormat } from '../../../helper/dataFormat';
import { EmptyDataComponent } from '../../common/EmptyData/EmptyDataComponent';
import { getStateInfo } from '../../../helper/stateTranslate';
import { CircleStatusComponent } from '../../common/CircleStatusSpan/CircleStatusComponent';


export const AdminLogsTable = ({ usersData, handleObject, loading, currentPagination, stateModel }) => {


    //?Manejo de la Paginacion con la Api
    logger.info('currentPagination: ', currentPagination)

    const [customObjet, setCustomObjet] = useState({
        PageSize: currentPagination.PageSize,
        PageIndex: currentPagination.PageIndex
    })

    useEffect(() => {
        setCustomObjet({
            PageSize: currentPagination.PageSize,
            PageIndex: currentPagination.PageIndex
        })
    }, [currentPagination])


    const handleChangePage = (newPage) => {
        console.log('newPage: ', newPage)
        const nuevoObjeto = {
            ...customObjet,
            PageIndex: newPage
        };
        setCustomObjet(nuevoObjeto);
        handleObject(nuevoObjeto)

    }

    logger.info('customObjet: ', customObjet)


    const handleChangeRowsPerPage = (newPageSize) => {
        const totalItems = usersData.totalFiltered || 0
        const globalIndex = (customObjet.PageIndex - 1) * customObjet.PageSize + 1
        const newPage = Math.ceil(globalIndex / newPageSize);


        const nuevoObjeto = {
            PageSize: newPageSize,
            PageIndex: newPage
        }
        setCustomObjet({
            PageSize: newPageSize,
            PageIndex: newPage
        })
        handleObject(nuevoObjeto)
    }


    //? Setea la cantidad de columnas visibles segun el ancho de la pantalla
    const { visibleCols } = UseSettingColumns()

    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(null);

    const showBootstrapModal = (id) => {
        setBootstrapModalStatus(id);
    }


    // const [currentPage, setCurrentPage] = useState(null);

    // const handlePageChange = (page) => {

    //     logger.info('page:', page)
    //     setCurrentPage(page);

    // };

    // const [onreached, setOnReached] = useState(second)
    const handleCheckboxChange = (row, checked) => {
        // logger.info('Usuario:', row, 'Checked:', checked);
    };


    //? Traduccion de estados 



    const stateToTranslate = (state) => {
        if (usersData.items) {

            const getState = getStateInfo(stateModel, state)
            logger.info('status translationStatus: ', getState)

            return getState.stateString
        }
    }

    const allColumns = [
        {
            name: 'Email',
            selector: row => `${row.emailTo}`,
            cell: row => (
                (row.emailTo ?

                    <CircleStatusComponent
                        isVisible={visibleCols <= 2}
                        name={row.emailTo}
                        state={row.outboxStatus}
                    />
                    : null
                )

            ),
            width: '300px',
        },

        {
            name: 'Tipo',
            selector: row => row.outboxType,
            sortable: true,
        },

        {
            name: 'Estado',
            cell: row => (

                row.outboxStatus &&
                <span className={`span-status span-${row.outboxStatus.toLowerCase()}`}>
                    {/* {row.state} */}

                    {stateToTranslate(row.outboxStatus)}
                </span>
            ),
            sortable: true,

        },
        {
            name: 'Fecha',
            selector: row => dateFormat(row.createdDate, true),

        },
        {
            name: 'Intentos',
            selector: row => row.attempts,

        },
        {
            name: 'Mensaje',
            selector: row => row.message,

        },

    ];

    const columns = allColumns.slice(0, visibleCols); // Seleccionar solo las columnas visibles
    const hiddenColumns = allColumns.slice(visibleCols); // Obtener las columnas ocultas
    const maxHeightScroll = `${window.innerHeight * 0.57}px`;
    logger.info('columns: ', columns, 'hiddenColumns: ', hiddenColumns)

    //? Componente expandible para las filas que muestra las columnas ocultas
    const ExpandedComponent = ({ data }) => (
        <div style={{ padding: '10px', background: '#f9f9f9' }}>
            {hiddenColumns.length === 0 ? (
                <i>No hay más datos ocultos.</i>
            ) : (
                <table>
                    <tbody>
                        {hiddenColumns.map((col, index) => (
                            <tr key={index}>
                                <td style={{ fontWeight: 'bold', paddingRight: 10 }}>{col.name}:</td>
                                <td>
                                    {col.selector
                                        ? col.selector(data)
                                        : col.cell
                                            ? col.cell(data)
                                            : '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {/* Mostrar acciones en la fila expandida */}
            {visibleCols < 7 ? null : <div className="acciones">
                {/* <button className="btn toTooltip" title="Rechazar">
                    <span className="material-icons mI-table">cancel</span>
                </button>
                <button className="btn toTooltip" title="Reenviar">
                    <span className="material-icons mI-table">forward_to_inbox</span>
                </button>
                <a href="#" className="btn btn-user-info" title="Info">
                    <span className="material-icons mI-table">visibility</span>
                </a> */}
            </div>}

        </div>
    )

    return (
        <motion.div
            className="dataTableStyle react-dataTable-Style"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <DataTable
                title="Usuarios"
                columns={columns}
                data={usersData.items}
                responsive
                highlightOnHover
                striped
                noHeader
                expandableRows={hiddenColumns.length > 0} // Solo permite expandir si hay columnas ocultas
                expandableRowsComponent={ExpandedComponent} // Componente que se muestra al expandir
           
                //? evita el scroll de la tabla
                // fixedHeader
                // fixedHeaderScrollHeight={maxHeightScroll}
                
                //? propiedad para cuando el array esta vacio 
                noDataComponent={
                    <EmptyDataComponent />
                }

                pagination
                paginationServer
                paginationPerPage={customObjet.PageSize}
                paginationTotalRows={usersData.totalFiltered || 0}
                paginationDefaultPage={customObjet.PageIndex}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                paginationComponent={CustomPagination}

                // paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50]}


                customStyles={{
                    cells: {
                        style: {
                            padding: '8px', // Ajustar el padding de las celdas
                        },
                    },
                }}
                conditionalRowStyles={[
                    {
                        when: row => true, // o cualquier condición
                        classNames: ['row-style'],
                    },
                ]}

                //! Hace ferencia a la fila clickeada y muestra por consola los datos, util para obtener el id del usuario
                onRowClicked={(row) => {
                    // logger.info('ID del usuario clickeado:', row.id) // 👈 incluso si no lo mostrás

                    logger.info('ID del usuario clickeado:', row.id)




                }}

                //! LOADING
                progressPending={loading} // 👉cuando true muestra loader
                // progressComponent={<div>Cargando usuarios...</div>}
                progressComponent={<LoadingComponent />}
            // progressComponent={<SkeletonLoader/>}

            />


        </motion.div>

    );
}

